import { cn } from '@/lib/cn';

/**
 * Лента „колко е пълен бусът" — по тегло или по обем. Зелено до 85 %, акцент
 * (пълен) до 100 %, червено над товароносимостта. Без данни — сиво с „не е
 * въведено": празна лента лъже, че бусът е празен.
 */
export function LoadBar({
  label,
  value,
  max,
  unit,
  digits = 0,
  className,
}: {
  label: string;
  value: number;
  max: number | null;
  unit: string;
  digits?: number;
  className?: string;
}) {
  const fmt = (n: number) => n.toLocaleString('bg-BG', { maximumFractionDigits: digits, minimumFractionDigits: 0 });
  const pct = max && max > 0 ? Math.round((value * 100) / max) : null;
  const tone =
    pct === null ? 'bg-line-strong' : pct > 100 ? 'bg-danger' : pct >= 85 ? 'bg-accent' : 'bg-ok';
  return (
    <div className={cn('min-w-0', className)}>
      <div className="flex items-baseline justify-between gap-2 text-[11px]">
        <span className="uppercase tracking-wide text-ink-faint">{label}</span>
        <span className={cn('font-mono tabular', pct !== null && pct > 100 ? 'text-danger' : 'text-ink')}>
          {fmt(value)}
          {max !== null ? ` / ${fmt(max)}` : ''} {unit}
          {pct !== null ? <span className="text-ink-faint"> · {pct} %</span> : null}
        </span>
      </div>
      <div className="mt-1 h-1.5 overflow-hidden rounded-full bg-raised">
        {pct === null ? (
          <div className="h-full w-full bg-line-strong/40" title="Не е въведено" />
        ) : (
          <div className={cn('h-full rounded-full', tone)} style={{ width: `${Math.min(100, pct)}%` }} />
        )}
      </div>
      {max === null ? <div className="mt-0.5 text-[10px] text-ink-faint">капацитетът на буса не е въведен</div> : null}
    </div>
  );
}
